import { unwrapResult } from '@reduxjs/toolkit'
import { thunkGetAccountProfile } from 'app/authSlice'
import dayjs from 'dayjs'
import ProgressCustom from 'general/components/Progress'
import PreferenceKeys from 'general/constants/PreferenceKeys'
import wsHelperInstance from 'general/helpers/WebSocketHelper'
import Utils from 'general/utils/Utils'
import { useAppSelector } from 'hooks/useRedux'
import { useMemo, useState } from 'react'
import { useDispatch } from 'react-redux'
import { shallowEqual } from 'react-redux'

export default function ResourceStatistics(props) {
  const sysType = useAppSelector((state) => state.auth.activeInvoice)
  const dispatch = useDispatch()
  const [items, setItems] = useState([])
  const resource_invoice = useAppSelector(
    (state) => state.auth.resource?.invoice,
    shallowEqual,
  )
  const resource_ticket = useAppSelector(
    (state) => state.auth.resource?.ticket,
    shallowEqual,
  )

  const resource_tncn = useAppSelector(
    (state) => state.auth.resource?.tncn,
    shallowEqual,
  )
  const reportFileDetail = useAppSelector(
    (state) => state.auth.reportFileDetail,
    shallowEqual,
  )

  const resetResouce = async () => {
    return await dispatch(thunkGetAccountProfile())
  }

  const isFutureDate = (inputDateStr) => {
    return dayjs(inputDateStr).isAfter(dayjs())
  }

  useMemo(() => {
    resetResouce()
  }, [])

  useMemo(() => {
    // props?.setInforExportReportFileDetail({ disable: reportFileDetail })
    // if (reportFileDetail) {
    //   let accessToken = localStorage.getItem(PreferenceKeys.accessToken)
    //   wsHelperInstance.onExecutingReportFile(
    //     accessToken,
    //     props?.setInforExportReportFileDetail,
    //     reportFileDetail,
    //   )
    // }
  }, [reportFileDetail])

  useMemo(() => {
    setItems(
      [
        {
          title: sysType.invoice
            ? 'Số hoá đơn còn lại'
            : sysType.ticket
              ? 'Số vé còn lại'
              : 'Số chứng từ còn lại',
          // hidden: sysType.personalIncomeTax,
          value: sysType.invoice
            ? resource_invoice?.quantity
            : sysType.ticket
              ? resource_ticket?.quantity
              : resource_tncn?.quantity,
          type: 'number',
        },
        {
          title: 'Thời hạn sử dụng',
          // hidden: sysType.invoice
          //   ? resource_invoice?.dateExpiredNew != 'Hết hạn'
          //   : sysType.ticket
          //     ? sysType.ticket?.dateExpiredNew != 'Hết hạn'
          //     : sysType.resource_tncn
          //       ? sysType.resource_tncn?.dateExpiredNew != 'Hết hạn'
          //       : true,

          // value: sysType.invoice
          //   ? resource_invoice?.dateExpiredNew
          //   : sysType.ticket
          //     ? resource_ticket?.dateExpiredNew
          //     : resource_tncn?.dateExpiredNew,
          hidden: isFutureDate(resource_invoice?.dateExpired),
          value: resource_invoice?.dateExpiredNew,
        },
      ],
      [
        resource_invoice?.dateExpiredNew,
        resource_invoice?.quantity,
        resource_ticket?.dateExpiredNew,
        resource_ticket?.quantity,
        resource_tncn?.dateExpiredNew,
        resource_tncn?.quantity,
        sysType.invoice,
        sysType.ticket,
        sysType.tncn,
      ],
    )
  }, [sysType])

  return (
    <div className="px-3 pb-2 aside-support">
      {/* <ProgressCustom
        title={'Báo cáo hóa đơn'}
        setInforExportReportFileDetail={props?.setInforExportReportFileInvoice}
        inforExportReportFileDetail={props?.inforExportReportFileInvoice}
        progressKey="totalBaoCaoHoaDonDaSuDung"
      /> */}
      <ProgressCustom
        title={'Báo cáo chi tiết'}
        setInforExportReportFileDetail={props?.setInforExportReportFileDetail}
        inforExportReportFileDetail={props?.inforExportReportFileDetail}
      />
      {items.map((item, index) => (
        <div
          key={index}
          className={Utils.cn(
            ' flex-column text-white',
            item.hidden ? 'd-none' : 'd-flex',
          )}
        >
          <span className="fs-6">{`${item.title}:`}</span>
          <span className="fw-semibold fs-5">
            {item.type === 'number'
              ? Utils.formatNumber(item.value ?? 0)
              : item.value}
          </span>
        </div>
      ))}
    </div>
  )
}
